import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

export function AutoLogin() {
  const auth0 = useAuth0();
  const location = useLocation();

  useEffect(
    function () {
      auth0.loginWithRedirect({
        appState: {
          returnTo: location.pathname,
        },
      });
    },
    [auth0, location.pathname],
  );

  return null;
}
